var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('resource-table',{attrs:{"columns":_vm.columns,"fetch-data":_vm.fetchLevels},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('md-button',{staticClass:"md-icon-button md-raised md-round md-info",on:{"click":function($event){return _vm.goToView(item.id)}}},[_c('md-icon',[_vm._v("edit")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }